import { createSlice } from '@reduxjs/toolkit'

const documentSlice = createSlice({
    name: 'document',
    initialState: {
        slug: null,
    },
    reducers: {
        setSlug(state, action) {
            return action.payload
        },
    },
})

const { actions, reducer } = documentSlice

export const { setSlug } = actions

export default reducer
